<script lang="ts">
    import { fade } from "svelte/transition";

    import { getContext } from "svelte";
    import type { Writable } from "svelte/store";
    import type { Seconds } from "../../../../../modules/vu-player-models/time/seconds";
    import type { SkinState, State } from "../../types/state";
    let state: Writable<State> = getContext("playerState");
    let skinState: Writable<SkinState> = getContext("skinState");

    import Button from "../shared/Button.svelte";

    import { overlayTransitionDuration } from "./../../utils/constants";

    $: showClips =
        !$skinState.isOverlayHidden &&
        !$skinState.isSettingsOpen &&
        $skinState.showClipControls;

    function skip(time: Seconds) {
        $state.adapter?.skipTo(time);
    }

    function skipFrameBackward() {
        skip(-1 * getFrameTime());
    }

    function skipFrameForward() {
        skip(getFrameTime());
    }

    function getFrameTime() {
        const playerFrameRate = $state.activeVideoTrack?.frameRate ?? NaN;
        const isPlayerFrameRateInvalid = isNaN(playerFrameRate);
        const frameRate = isPlayerFrameRateInvalid
            ? $skinState.defaultFrameRate
            : playerFrameRate;

        return 1 / frameRate;
    }
</script>

{#if showClips}
    <div
        class="scotparl-clip-controls"
        transition:fade={{ duration: overlayTransitionDuration }}
    >
        <div class="spacer" />
        <Button
            label="skip backward 30 seconds"
            on:click={() => {
                skip(-30);
            }}
        >
            -30s
        </Button>
        <Button
            label="skip backward 10 seconds (j)"
            on:click={() => {
                skip(-10);
            }}
        >
            -10s
        </Button>
        <Button
            label="skip backward 5 seconds"
            on:click={() => {
                skip(-5);
            }}
        >
            -5s
        </Button>
        <Button
            label="skip backward 1 second"
            on:click={() => {
                skip(-1);
            }}
        >
            -1s
        </Button>
        <Button label="skip backward 1 frame" on:click={skipFrameBackward}>
            -1f
        </Button>
        <Button label="skip forward 1 frame" on:click={skipFrameForward}>
            +1f
        </Button>
        <Button
            label="skip forward 1 second"
            on:click={() => {
                skip(1);
            }}
        >
            +1s
        </Button>
        <Button
            label="skip forward 5 seconds"
            on:click={() => {
                skip(5);
            }}
        >
            +5s
        </Button>
        <Button
            label="skip forward 10 seconds (l)"
            on:click={() => {
                skip(10);
            }}
        >
            +10s
        </Button>
        <Button
            label="skip forward 30 seconds"
            on:click={() => {
                skip(30);
            }}
        >
            +30s
        </Button>
        <div class="spacer" />
    </div>
{/if}

<style lang="scss">
    .scotparl-clip-controls {
        background-color: rgb(0 0 0 / 50%);
        position: absolute;
        bottom: 5em;

        display: flex;

        width: 100%;
        height: 3em;

        .spacer {
            flex: 1;
        }
    }
    @media screen and (max-width: 500px) {
        .scotparl-clip-controls {
            display: none;
        }
    }
</style>
